export const navMenuArray = {
    "NavMenuPermission": [
        {
            "title": "Dashboard",
            "navMenuId": 1,
            "menuURL": "dashboard",
            "iconClass": "m-menu__link-icon fa fa-dashboard"
        },
        {
            "title": "Contact",
            "navMenuId": 2,
            "menuURL": "contact",
            "iconClass": "m-menu__link-icon fa fa-user"
        },
        {
            "title": "Inventory",
            "navMenuId": 3,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-cubes"
        },
        {
            "title": "Employee",
            "navMenuId": 21,
            "menuURL": "employee",
            "iconClass": "m-menu__link-icon fa fa-user"
        },
        {
            "title": "Coupons & Membership (BETA)",
            "navMenuId": 17,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa  fa-gift"
        },
        {
            "title": "Purchase",
            "navMenuId": 4,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-shopping-bag"
        },
        {
            "title": "Sales",
            "navMenuId": 5,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-shopping-cart"
        },
        {
            "title": "Bank / Cash",
            "navMenuId": 6,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-bank"
        },
        {
            "title": "POS",
            "navMenuId": 9,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-fax"
        },
        {
            "title": "Branch",
            "navMenuId": 11,
            "menuURL": "branch",
            "iconClass": "m-menu__link-icon fa fa-sitemap"
        },
        {
            "title": "Accounting",
            "navMenuId": 7,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-calculator"
        },
        {
            "title": "Report",
            "navMenuId": 10,
            "menuURL": "report",
            "iconClass": "m-menu__link-icon fa fa-bar-chart-o"
        },
        {
            "title": "Report (BETA)",
            "navMenuId": 16,
            "menuURL": "report/beta",
            "iconClass": "m-menu__link-icon fa fa-bar-chart-o"
        },
        {
            "title": "Gate Management",
            "navMenuId": 18,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-id-card"
        },
        {
            "title": "Utilities",
            "navMenuId": 19,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-file"
        },
        {
            "title": "Production",
            "navMenuId": 20,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-file"
        },
        {
            "title": "Settings",
            "navMenuId": 8,
            "menuURL": "#",
            "iconClass": "m-menu__link-icon fa fa-gears"
        },
        {
            "title": "Versions",
            "navMenuId": 13,
            "menuURL": "changelog",
            "iconClass": "m-menu__link-icon fa fa-history"
        }
    ],
    "NavSubMenuPermission": [
        {
            "type": "stock",
            "navSubMenuId": 95,
            "title": "Stock",
            "navMenuId": 3,
            "menuURL": "product/stock",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2,"
        },
        {
            "type": "accounts",
            "navSubMenuId": 22,
            "title": "Account",
            "navMenuId": 7,
            "menuURL": "account",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "report",
            "navSubMenuId": 34,
            "title": "Reports",
            "navMenuId": 10,
            "menuURL": "report",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2,"
        },
        {
            "type": "reportbeta",
            "navSubMenuId": 104,
            "title": "Reports (BETA)",
            "navMenuId": 16,
            "menuURL": "report/beta",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2,"
        },
        {
            "type": "purchasetermsandcondition",
            "navSubMenuId": 80,
            "title": "Purchase Terms and conditions",
            "navMenuId": 8,
            "menuURL": "purchase/termsandcondition",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "barcodeutility",
            "navSubMenuId": 113,
            "title": "barcode utility",
            "navMenuId": 19,
            "menuURL": "barcodeutility",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "salestermsandcondition",
            "navSubMenuId": 26,
            "title": "Sales Terms and conditions",
            "navMenuId": 8,
            "menuURL": "termsandcondition",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "coupon",
            "navSubMenuId": 106,
            "title": "Coupon",
            "navMenuId": 17,
            "menuURL": "coupon",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "posnew",
            "navSubMenuId": 33,
            "title": "New",
            "navMenuId": 9,
            "menuURL": "pos/new",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "generalsetting",
            "navSubMenuId": 114,
            "title": "General Setting",
            "navMenuId": 8,
            "menuURL": "setting/general",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "suppliers",
            "navSubMenuId": 3,
            "title": "Suppliers",
            "navMenuId": 2,
            "menuURL": "contact/suppliers",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "materialgatepass",
            "navSubMenuId": 109,
            "title": "Material Gatepass",
            "navMenuId": 18,
            "menuURL": "materialgatepass",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "documents",
            "navSubMenuId": 111,
            "title": "Documents",
            "navMenuId": 19,
            "menuURL": "drive",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "estimate",
            "navSubMenuId": 15,
            "title": "Estimate",
            "navMenuId": 5,
            "menuURL": "sales/estimate",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "accountgroup",
            "navSubMenuId": 139,
            "title": "Account Group",
            "navMenuId": 7,
            "menuURL": "accountgroup",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "bank",
            "navSubMenuId": 18,
            "title": "Bank",
            "navMenuId": 6,
            "menuURL": "bank",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "order",
            "navSubMenuId": 12,
            "title": "Purchase Order",
            "navMenuId": 4,
            "menuURL": "purchase/order",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "dashboardcustomerview",
            "navSubMenuId": 55,
            "title": "Customer View",
            "navMenuId": 1,
            "menuURL": "dashboardcustomerview",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "product",
            "navSubMenuId": 5,
            "title": "Product",
            "navMenuId": 3,
            "menuURL": "product",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "customercategory",
            "navSubMenuId": 110,
            "title": "Customer Category",
            "navMenuId": 8,
            "menuURL": "customercategory",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "dashboard",
            "navSubMenuId": 2,
            "title": "Dashboard",
            "navMenuId": 1,
            "menuURL": "dashboard",
            "ordering": 1,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2,"
        },
        {
            "type": "customers",
            "navSubMenuId": 4,
            "title": "Customers",
            "navMenuId": 2,
            "menuURL": "contact/customers",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "inventorysetting",
            "navSubMenuId": 115,
            "title": "Inventory Setting",
            "navMenuId": 8,
            "menuURL": "setting/inventory",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "membershipmaster",
            "navSubMenuId": 100,
            "title": "Membership",
            "navMenuId": 17,
            "menuURL": "membershipmaster",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "salesorder",
            "navSubMenuId": 40,
            "title": "Sales Order",
            "navMenuId": 5,
            "menuURL": "sales/order",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "dashboardsuppliersview",
            "navSubMenuId": 56,
            "title": "Suppliers View",
            "navMenuId": 1,
            "menuURL": "dashboardsuppliersview",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "contact",
            "navSubMenuId": 140,
            "title": "Contact",
            "navMenuId": 2,
            "menuURL": "contact",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "debit_note_accounting",
            "navSubMenuId": 23,
            "title": "Debit Note",
            "navMenuId": 7,
            "menuURL": "debitnote",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "BANK_TRANSACTION",
            "navSubMenuId": 19,
            "title": "Bank Transaction",
            "navMenuId": 6,
            "menuURL": "banktransaction",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "prefix",
            "navSubMenuId": 27,
            "title": "Prefix",
            "navMenuId": 8,
            "menuURL": "prefix",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "materialinward",
            "navSubMenuId": 94,
            "title": "Material Inward",
            "navMenuId": 4,
            "menuURL": "purchase/materialinward",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "POS",
            "navSubMenuId": 48,
            "title": "In Store Order List",
            "navMenuId": 9,
            "menuURL": "report/pos",
            "ordering": 2,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "category_brand",
            "navSubMenuId": 6,
            "title": "Category / Brand",
            "navMenuId": 3,
            "menuURL": "categorybrand",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "vendors",
            "navSubMenuId": 44,
            "title": "Vendors",
            "navMenuId": 2,
            "menuURL": "contact/vendors",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "invoice",
            "navSubMenuId": 16,
            "title": "Invoice",
            "navMenuId": 5,
            "menuURL": "sales/invoice",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "credit_note_accounting",
            "navSubMenuId": 24,
            "title": "Credit Note",
            "navMenuId": 7,
            "menuURL": "creditnote",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "discount",
            "navSubMenuId": 11,
            "title": "Discount",
            "navMenuId": 17,
            "menuURL": "discount",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "dashboardproductview",
            "navSubMenuId": 57,
            "title": "Product View",
            "navMenuId": 1,
            "menuURL": "dashboardproductview",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "posonline",
            "navSubMenuId": 97,
            "title": "Online Order List",
            "navMenuId": 9,
            "menuURL": "report/pos/online",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "employee",
            "navSubMenuId": 38,
            "title": "Employee",
            "navMenuId": 21,
            "menuURL": "employee",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "bill",
            "navSubMenuId": 13,
            "title": "Supplier Bill",
            "navMenuId": 4,
            "menuURL": "purchase/bill",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "transport",
            "navSubMenuId": 73,
            "title": "Transport",
            "navMenuId": 2,
            "menuURL": "contact/transport",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "additionalcharge",
            "navSubMenuId": 28,
            "title": "Additional Charge",
            "navMenuId": 8,
            "menuURL": "additionalcharge",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "possetting",
            "navSubMenuId": 116,
            "title": "POS Setting",
            "navMenuId": 8,
            "menuURL": "setting/pos",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "payment",
            "navSubMenuId": 20,
            "title": "Payment",
            "navMenuId": 6,
            "menuURL": "payment",
            "ordering": 3,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "poscreditnote",
            "navSubMenuId": 47,
            "title": "Credit Note",
            "navMenuId": 9,
            "menuURL": "pos/creditnote",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "term",
            "navSubMenuId": 29,
            "title": "Payment Terms",
            "navMenuId": 8,
            "menuURL": "paymentterm",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "debitnote",
            "navSubMenuId": 14,
            "title": "Debit Note",
            "navMenuId": 4,
            "menuURL": "purchase/debitnote",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "JOURNAL_VOUCHER",
            "navSubMenuId": 25,
            "title": "Journal Voucher",
            "navMenuId": 7,
            "menuURL": "journalvoucher",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "unitofmeasurement",
            "navSubMenuId": 7,
            "title": "Unit Of Measurement",
            "navMenuId": 3,
            "menuURL": "uom",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "receipt",
            "navSubMenuId": 21,
            "title": "Receipt",
            "navMenuId": 6,
            "menuURL": "receipt",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "dashboardtotalstockview",
            "navSubMenuId": 58,
            "title": "Total Stock View",
            "navMenuId": 1,
            "menuURL": "dashboardtotalstockview",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "deliverychallan",
            "navSubMenuId": 102,
            "title": "Delivery Challan",
            "navMenuId": 5,
            "menuURL": "sales/deliverychallan",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "notificationssetting",
            "navSubMenuId": 117,
            "title": "Notifications Setting",
            "navMenuId": 8,
            "menuURL": "setting/notifications",
            "ordering": 4,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "tax",
            "navSubMenuId": 8,
            "title": "Tax",
            "navMenuId": 3,
            "menuURL": "tax",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "creditnote",
            "navSubMenuId": 17,
            "title": "Credit Note",
            "navMenuId": 5,
            "menuURL": "sales/creditnote",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "purchasesetting",
            "navSubMenuId": 118,
            "title": "Purchase Setting",
            "navMenuId": 8,
            "menuURL": "setting/purchase",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "dashboardcashinhandview",
            "navSubMenuId": 59,
            "title": "Cash In Hand View",
            "navMenuId": 1,
            "menuURL": "dashboardcashinhandview",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "expense",
            "navSubMenuId": 43,
            "title": "Expense",
            "navMenuId": 6,
            "menuURL": "expense",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "salesregister",
            "navSubMenuId": 49,
            "title": "Sales Register",
            "navMenuId": 9,
            "menuURL": "salesregister",
            "ordering": 5,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "stocktransfer",
            "navSubMenuId": 9,
            "title": "Stock Transfer",
            "navMenuId": 3,
            "menuURL": "stocktransfer",
            "ordering": 6,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,6,7"
        },
        {
            "type": "dashboardbankaccountview",
            "navSubMenuId": 60,
            "title": "Bank Account View",
            "navMenuId": 1,
            "menuURL": "dashboardbankaccountview",
            "ordering": 6,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "salessetting",
            "navSubMenuId": 119,
            "title": "Sales Setting",
            "navMenuId": 8,
            "menuURL": "setting/sales",
            "ordering": 6,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "CASH_FLOW_TRANSACTION",
            "navSubMenuId": 65,
            "title": "Owner Cash Flow",
            "navMenuId": 6,
            "menuURL": "owner/cashflow",
            "ordering": 6,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "financialyear",
            "navSubMenuId": 31,
            "title": "Financial Year",
            "navMenuId": 8,
            "menuURL": "financialyear",
            "ordering": 6,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "CASH_FLOW_TRANSACTION",
            "navSubMenuId": 66,
            "title": "Manager Cash Flow",
            "navMenuId": 6,
            "menuURL": "manager/cashflow",
            "ordering": 7,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "ordermanagement",
            "navSubMenuId": 77,
            "title": "OrderManagement",
            "navMenuId": 5,
            "menuURL": "order-management",
            "ordering": 7,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "integrationsetting",
            "navSubMenuId": 120,
            "title": "Integration Setting",
            "navMenuId": 8,
            "menuURL": "setting/integrations",
            "ordering": 7,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "dashboardreceivableoutstandingview",
            "navSubMenuId": 61,
            "title": "Receivable Outstanding",
            "navMenuId": 1,
            "menuURL": "dashboardreceivableoutstandingview",
            "ordering": 7,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "agent",
            "navSubMenuId": 103,
            "title": "Agent",
            "navMenuId": 2,
            "menuURL": "contact/agent",
            "ordering": 7,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "reportsetting",
            "navSubMenuId": 42,
            "title": "Report Setting",
            "navMenuId": 8,
            "menuURL": "reportsetting",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,"
        },
        {
            "type": "department",
            "navSubMenuId": 37,
            "title": "Department",
            "navMenuId": 3,
            "menuURL": "department",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "internaltransfer_transaction",
            "navSubMenuId": 105,
            "title": "Cash Flow",
            "navMenuId": 6,
            "menuURL": "manager/internaltransfer",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "logssetting",
            "navSubMenuId": 121,
            "title": "Logs Setting",
            "navMenuId": 8,
            "menuURL": "setting/logs",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "decimal_setting",
            "navSubMenuId": 53,
            "title": "Decimal Setting",
            "navMenuId": 8,
            "menuURL": "setting",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,"
        },
        {
            "type": "dashboardpayableoutstandingview",
            "navSubMenuId": 62,
            "title": "Payable Outstanding View",
            "navMenuId": 1,
            "menuURL": "dashboardpayableoutstandingview",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "activitylog",
            "navSubMenuId": 69,
            "title": "Activity Log",
            "navMenuId": 8,
            "menuURL": "activitylog",
            "ordering": 8,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,"
        },
        {
            "type": "ecommercesetting",
            "navSubMenuId": 122,
            "title": "Ecommerce Setting",
            "navMenuId": 8,
            "menuURL": "setting/ecommerce",
            "ordering": 9,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "citymaster",
            "navSubMenuId": 45,
            "title": "City Master",
            "navMenuId": 8,
            "menuURL": "location/city",
            "ordering": 9,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "dashboardsalesinvoiceview",
            "navSubMenuId": 63,
            "title": "Sales Invoice",
            "navMenuId": 1,
            "menuURL": "dashboardsalesinvoiceview",
            "ordering": 9,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "stockverification",
            "navSubMenuId": 39,
            "title": "Stock Verification",
            "navMenuId": 3,
            "menuURL": "stockverification",
            "ordering": 9,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,6,7"
        },
        {
            "type": "dashboardsalesposview",
            "navSubMenuId": 64,
            "title": "Sales POS",
            "navMenuId": 1,
            "menuURL": "dashboardsalesposview",
            "ordering": 10,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "2"
        },
        {
            "type": "localitymaster",
            "navSubMenuId": 46,
            "title": "Locality Master",
            "navMenuId": 8,
            "menuURL": "location/locality",
            "ordering": 10,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "stocktransferrequest",
            "navSubMenuId": 54,
            "title": "Stock Transfer Request",
            "navMenuId": 3,
            "menuURL": "stocktransferrequest",
            "ordering": 10,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "userrole",
            "navSubMenuId": 41,
            "title": "User Role",
            "navMenuId": 8,
            "menuURL": "userrole",
            "ordering": 11,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3"
        },
        {
            "type": "settingpricing",
            "navSubMenuId": 123,
            "title": "Pricing",
            "navMenuId": 8,
            "menuURL": "setting/pricing",
            "ordering": 11,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "billofmaterials",
            "navSubMenuId": 68,
            "title": "Bill Of Materials",
            "navMenuId": 3,
            "menuURL": "billofmaterials",
            "ordering": 11,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "predefineproductattribute",
            "navSubMenuId": 72,
            "title": "Predefine Product Attribute",
            "navMenuId": 8,
            "menuURL": "predefineproductattribute",
            "ordering": 12,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "recipe",
            "navSubMenuId": 70,
            "title": "Recipe",
            "navMenuId": 3,
            "menuURL": "recipe",
            "ordering": 12,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "productb2bmapping",
            "navSubMenuId": 107,
            "title": "B2B Product Price Mapping",
            "navMenuId": 3,
            "menuURL": "product/productb2bmapping",
            "ordering": 12,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "settingstock",
            "navSubMenuId": 124,
            "title": "Stock",
            "navMenuId": 8,
            "menuURL": "setting/stock",
            "ordering": 12,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "settingbarcodes",
            "navSubMenuId": 125,
            "title": "Barcodes",
            "navMenuId": 8,
            "menuURL": "setting/barcodes",
            "ordering": 13,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "emailsetting",
            "navSubMenuId": 76,
            "title": "Email Setting",
            "navMenuId": 8,
            "menuURL": "emailsetting",
            "ordering": 13,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "companysetting",
            "navSubMenuId": 75,
            "title": "Company Setting",
            "navMenuId": 8,
            "menuURL": "setting/companysetting",
            "ordering": 13,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "materialconsumption",
            "navSubMenuId": 84,
            "title": "Material Consumption",
            "navMenuId": 3,
            "menuURL": "materialconsumption",
            "ordering": 13,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4"
        },
        {
            "type": "whatsapp",
            "navSubMenuId": 74,
            "title": "Whatsapp",
            "navMenuId": 8,
            "menuURL": "whatsapp",
            "ordering": 13,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingproduction",
            "navSubMenuId": 126,
            "title": "Production",
            "navMenuId": 8,
            "menuURL": "setting/production",
            "ordering": 14,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "inventoryTracking",
            "navSubMenuId": 86,
            "title": "Stock  Verification",
            "navMenuId": 3,
            "menuURL": "inventorytracking",
            "ordering": 14,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,6,7"
        },
        {
            "type": "b2bproductsetting",
            "navSubMenuId": 108,
            "title": "B2B Product Setting",
            "navMenuId": 8,
            "menuURL": "product/b2bproduct/setting",
            "ordering": 14,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingb2b",
            "navSubMenuId": 127,
            "title": "B2B",
            "navMenuId": 8,
            "menuURL": "setting/b2b",
            "ordering": 15,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "deliveryCharges",
            "navSubMenuId": 82,
            "title": "Delivery Charge",
            "navMenuId": 8,
            "menuURL": "deliverycharges",
            "ordering": 16,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingsmslog",
            "navSubMenuId": 128,
            "title": "Sms Logs",
            "navMenuId": 8,
            "menuURL": "setting/smslog",
            "ordering": 17,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "smstemplate",
            "navSubMenuId": 83,
            "title": "SMS Template",
            "navMenuId": 8,
            "menuURL": "smstemplate",
            "ordering": 17,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingactivitylog",
            "navSubMenuId": 129,
            "title": "User Activity Log",
            "navMenuId": 8,
            "menuURL": "setting/activitylog",
            "ordering": 18,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "smslog",
            "navSubMenuId": 78,
            "title": "SMS Log",
            "navMenuId": 8,
            "menuURL": "smslog",
            "ordering": 18,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "2"
        },
        {
            "type": "settinglocality",
            "navSubMenuId": 130,
            "title": "Locality",
            "navMenuId": 8,
            "menuURL": "setting/locality",
            "ordering": 19,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "settingdeliverypartners",
            "navSubMenuId": 131,
            "title": "Delivery Partners",
            "navMenuId": 8,
            "menuURL": "setting/deliverypartner",
            "ordering": 20,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "hardware",
            "navSubMenuId": 132,
            "title": "Hardware",
            "navMenuId": 8,
            "menuURL": "hardware",
            "ordering": 21,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "deliverypartner",
            "navSubMenuId": 93,
            "title": "Delivery Partner",
            "navMenuId": 8,
            "menuURL": "deliverypartner",
            "ordering": 22,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingecommerce",
            "navSubMenuId": 133,
            "title": "Ecommerce",
            "navMenuId": 8,
            "menuURL": "setting/ecommerce",
            "ordering": 22,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "settingpayment",
            "navSubMenuId": 134,
            "title": "Payment Settings",
            "navMenuId": 8,
            "menuURL": "setting/payment",
            "ordering": 23,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "serviceablearea",
            "navSubMenuId": 96,
            "title": "Serviceable Area",
            "navMenuId": 8,
            "menuURL": "serviceablearea",
            "ordering": 23,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4"
        },
        {
            "type": "settingmessage",
            "navSubMenuId": 135,
            "title": "Messages/Emails",
            "navMenuId": 8,
            "menuURL": "setting/messages",
            "ordering": 24,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "settingloyalty",
            "navSubMenuId": 136,
            "title": "Loyalty",
            "navMenuId": 8,
            "menuURL": "setting/loyalty",
            "ordering": 25,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        },
        {
            "type": "materialcreation",
            "navSubMenuId": 138,
            "title": "Material Creation",
            "navMenuId": 3,
            "menuURL": "materialcreation",
            "ordering": 26,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 1,
            "action": "1,2,3,4,5"
        },
        {
            "type": "settinggst",
            "navSubMenuId": 137,
            "title": "GST",
            "navMenuId": 8,
            "menuURL": "setting/gst",
            "ordering": 26,
            "iconClass": "m-menu__link-icon flaticon-line-graph",
            "isSubMenu": 0,
            "action": "1,2,3,4,5"
        }
    ]
}
